import styled from 'styled-components';
import { css } from 'styled-components';
import { SizeName } from '../../../types/buttonStyle';

interface ButtonWithIconTextProps {
  size: SizeName;
}

interface WrapperProps {
  rightIcon: boolean | undefined;
  noText?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  gap: ${(props) => (props.noText ? `4px;` : `8px`)};
  justify-content: center;
  text-align: center;

  ${(props) =>
    props.rightIcon
      ? css`
          flex-direction: row-reverse;
        `
      : null}
`;

export const ButtonWithIconText = styled.span<ButtonWithIconTextProps>`
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  font-family: 'PT Sans', sans-serif;
  display: flex;
  align-items: center;

  //xs and md font size
  ${(props) =>
    props.size === 'xs' || props.size === 'sm'
      ? css`
          font-size: 14px;
        `
      : null}

  // md and lg font size
  ${(props) =>
    props.size === 'md' || props.size === 'lg'
      ? css`
          font-size: 16px;
        `
      : null}
`;

//This wrapper will center the Icon in conjunction with text
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Badge = styled.div`
  background: ${(props) => props.theme.colors.theme.primary.default};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  color: ${(props) => props.theme.colors.text.white};
`;
